import Vue from 'vue';
import PerksFilters from './PerksFilters.vue';

Vue.component('perks-filters', PerksFilters);

new Vue({
    el: '#perksApp',
    components: {
        PerksFilters
    }
});
